import type { Answer, AnswerType } from '../../answer/models/Answer'

export const getDefaultAnswerValue = <T extends AnswerType>(type: T): Answer<T>['value'] => {
  switch (type) {
    case 'choice': {
      return { selected: false }
    }
    case 'text': {
      return { textInput: '' }
    }
    case 'video': {
      return { videoBlob: undefined }
    }
    case 'choiceText': {
      return { selected: false, textInput: '' }
    }
    case 'nps': {
      return { rating: undefined }
    }
    case 'slider': {
      return { value: undefined }
    }
    case 'maxDiffSet': {
      return {
        selectedForBest: false,
        selectedForWorst: false,
      }
    }
  }
  throw new TypeError('Unrecognised answer type - ' + type)
}
